import axios from 'axios';

import API_URL from '../../config';

export const DeudaService = {
    getEventos: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/v2/deudas/eventos`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    createEvento: async (data) => {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/api/v2/deudas/eventos`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    getDetallesEvento: async (idEvento) => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/v2/deudas/eventos/${idEvento}/detalles`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    asignarIndividual: async (idEvento, idCliente) => {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/api/v2/deudas/eventos/${idEvento}/asignar-individual`, { id_cliente: idCliente }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    updateEvento: async (idEvento, data) => {
        const token = localStorage.getItem('token');
        const response = await axios.put(`${API_URL}/api/v2/deudas/eventos/${idEvento}`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    updateAsignacion: async (idDetalle, data) => {
        const token = localStorage.getItem('token');
        const response = await axios.put(`${API_URL}/api/v2/deudas/asignaciones/${idDetalle}`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    deleteAsignacion: async (idDetalle) => {
        const token = localStorage.getItem('token');
        const response = await axios.delete(`${API_URL}/api/v2/deudas/asignaciones/${idDetalle}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    deleteEvento: async (idEvento) => {
        const token = localStorage.getItem('token');
        const response = await axios.delete(`${API_URL}/api/v2/deudas/eventos/${idEvento}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    }
};
